import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity } from 'react-native';
import { View } from 'react-native';
import Text, { Large } from '@dbk/ui-text';
import { ChevronDown } from '@dbk/ui-icons';
import { FormattedMessage } from '@dbk/format';
import ModalSelector from '../../components/common/modal-selector';
import { REPORT_PORTFOLIO_ID } from '../../../@extension/CH/src/screens/reports/constants';
import styles from './data-export-portfolio-selector.styles';

class DataExtractPortfolioSelector extends PureComponent {
  constructor() {
    super();

    this.state = {
      modalVisible: false,
    };

    this.handleTriggerPress = this.handleTriggerPress.bind(this);
    this.handlePortfolioSelect = this.handlePortfolioSelect.bind(this);
    this.handleModalDone = this.handleModalDone.bind(this);
    this.renderOption = this.renderOption.bind(this);
  }

  handleTriggerPress() {
    this.setState({
      modalVisible: true,
    });
  }

  handlePortfolioSelect(portfolio) {
    this.props.onPortfolioSelect(portfolio);
    this.handleModalDone();
  }

  handleModalDone() {
    this.setState({
      modalVisible: false,
    });
    this.forceUpdate();
  }

  renderOption(option, index) {
    const portfolio = this.props.portfolios[index];
    const selectedPortfolioDisplay = this.getPortfolioDisplay(portfolio);

    return (
      <View style={styles.option}>
        <Large testID={portfolio.title}>{selectedPortfolioDisplay}</Large>
      </View>
    );
  }

  getPortfolioDisplay(portfolio) {
    let portfolioRelId = '';
    if (
      this.props.onRsaAuthorised === true ||
      this.props.onVascoAuthorised === true
    ) {
      portfolioRelId =
        portfolio.relId !== null ? portfolio.relId : portfolio.title;
    } else if(portfolio.relId === null) {
        portfolioRelId =
          portfolio.title.substr(0, 1) + 'XXXXX' + portfolio.title.slice(6);
      } else {
        portfolioRelId =
          portfolio.relId.substr(0, 1) + 'XXXXX' + portfolio.relId.slice(6);
      }
    if(portfolio.id === REPORT_PORTFOLIO_ID ) 
      return this.props.messages["app.chedelivery.reports.allPortfolioTitle"];
    return `${portfolioRelId} - ${portfolio.referenceCurrency.toUpperCase()}`;
  }

  render() {
    const {
      portfolios,
      selectedPortfolio,
      messages,
    } = this.props;

    const { modalVisible } = this.state;

    const selectedPortfolioDisplay = this.getPortfolioDisplay(
      selectedPortfolio
    );

    return (
      <View style={styles.root}>
        <div id="portfolio-id">
          <TouchableOpacity
            style={styles.trigger}
            onPress={this.handleTriggerPress}
          >
            <Text className="selected-portfolio">
              {selectedPortfolioDisplay}
            </Text>
            <ChevronDown color="#999" width={14} height={8} />
          </TouchableOpacity>
        </div>
        <ModalSelector
          title={<FormattedMessage id="app.portfolios.selection" />}
          visible={modalVisible}
          options={portfolios}
          selectedOption={selectedPortfolio}
          renderOption={this.renderOption}
          onSelect={this.handlePortfolioSelect}
          onDone={this.handleModalDone}
          doneLabel={messages['app.common.closeText']}
          style={styles.root}
        />
      </View>
    );
  }
}

DataExtractPortfolioSelector.propTypes = {
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      referenceCurrency: PropTypes.string,
      relId: PropTypes.string,
      branchCode: PropTypes.number,
      dayChange: PropTypes.shape({
        percent: PropTypes.number,
      }),
    })
  ),
  selectedPortfolio: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    referenceCurrency: PropTypes.string,
    relId: PropTypes.string,
    branchCode: PropTypes.number,
  }),
  onPortfolioSelect: PropTypes.func,
};

export default DataExtractPortfolioSelector;
